export type V2 = [number, number]
export type V3 = [number, number, number]
export type V4 = [number, number, number, number]

export function ad2xyz(a: number, d: number): V3 {
  const cosd = Math.cos(d)
  return [
    cosd * Math.cos(a),
    cosd * Math.sin(a),
    Math.sin(d),
  ]
}

export function xyz2ad(x: number, y: number, z: number): V2 {
  const a = Math.atan2(y, x)
  const d = Math.atan2(z, Math.sqrt(x * x + y * y))
  return [a, d]
}

export function linspace(a: number, b: number, n: number, end = false) {
  const xs: number[] = []
  if (end) {
    --n
  }
  for (let i = 0; i < n; ++i) {
    const x = a + i / n * (b - a)
    xs.push(x)
  }
  return xs
}

export function clip(x: number, a: number, b: number) {
  return x < a ? a : (x > b ? b : x)
}
